    function validaIban(iban) {
        //Se pasa a Mayusculas
        iban = iban.toUpperCase();
        //Se quita los blancos de principio y final.
        iban = iban.trim();
        iban = iban.replace(/\s/g, ""); //Y se quita los espacios en blanco dentro de la cadena

        let letra1,letra2,num1,num2;
        let isbanaux;
        let numeroSustitucion;
        //La longitud debe ser siempre de 24 caracteres
        if (iban.length != 24) {
            return false;
        }

        // Se coge las primeras dos letras y se pasan a números
        letra1 = iban.substring(0, 1);
        letra2 = iban.substring(1, 2);        
        num1 = getNumIban(letra1);
        num2 = getNumIban(letra2);
        //Se sustituye las letras por números.
        isbanaux = String(num1) + String(num2) + iban.substring(2);
        // Se mueve los 6 primeros caracteres al final de la cadena.
        isbanaux = isbanaux.substring(6) + isbanaux.substring(0,6);

        //Se calcula el resto, llamando a la función modulo97, definida más abajo
        let resto = modulo97(isbanaux);
        if (resto == 1){
            return true;
        }else{
            return false;
        }
    }

    function modulo97(iban) {
        let parts = Math.ceil(iban.length/7);
        let remainer = "";

        for (let i = 1; i <= parts; i++) {
            remainer = String(parseFloat(remainer+iban.substr((i-1)*7, 7))%97);
        }

        return remainer;
    }

    function getNumIban(letra) {
        let letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';        
        return letras.search(letra) + 10;
    }
export default { validaIban }